/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useMemo, useRef, useState} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'

import {getCSS, getCSSVariableValue} from '../../../../../../_metronic/assets/ts/_utils'
import {useThemeMode} from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import { KTSVG } from '../../../../../../_metronic/helpers'
import { getShortMonthNameString } from '../../../../../utils/date'
import { LoadingSpan } from '../../../../components/Loadings/loadingSpan'
import useSize from '../../../../../hooks/useSize'

import styles from './barGraphModal.module.css';
import { Prognosis } from '../../../../../@types/plants'
import { ChartsResult } from '../../../../../@types/charts'

type Props = {
  className: string
  charts: any;
  prognostico?: number | null;
  largura: number
  myProg?: Prognosis | null;
  setShowCreateAppModal: React.Dispatch<React.SetStateAction<boolean>>;
}

// const BarGraph: React.FC<Props> = ({charts, setShowCreateAppModal, myProg}) => {

//   const chartRef = useRef<HTMLDivElement | null>(null)
//   const {mode} = useThemeMode()
//   const [selectedValue, setSelectedValue] = useState<any>(null);
//   const [myPrognostics, setMyPrognostics] = useState<any>(null);
//   const {width: largura} = useSize()
//   const [chartsValues, setChartsValues] = useState<ChartsResult>({
//     metaDates: [],
//     valores: [],
//     type: "" 
//   });

//   const handleChartDeploy = () => {
//     if (charts && Object.keys(charts).length > 0 && selectedValue && selectedValue !== "" && charts[selectedValue]) {
//       console.log("Rederizando: ", charts)
//       const selectedChart = charts[selectedValue];
//       const myMetaDates = selectedChart.type && (selectedChart.type === "mounth_charts" || selectedChart.type === "week_charts") 
//         ? selectedChart.dias
//         : selectedChart.type === "year_charts"
//         ? selectedChart.meses
//         : selectedChart.type === "total_charts"
//         ? selectedChart.anos 
//         : [];
  
//       const myValores = selectedChart.valores ? selectedChart.valores : [];

//       if(myProg){
//         if(charts && charts[selectedValue]["type"] === "week_charts"){
//           const value = getShortMonthNameString(selectedValue)
//           const value_prop = `prog_${value}`;
//           const value_final = myProg[value_prop];

//           const my_array = myMetaDates ? Array(myMetaDates.length).fill(parseFloat(((value_final)/30).toFixed(2))) : [] 
//           setMyPrognostics(my_array)
//         }
//       }
  
//       setChartsValues({
//         metaDates: myMetaDates,
//         valores: myValores,
//         type: ""
//       });
//     }
//   };

//   useEffect(() => {
//     handleChartDeploy()
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectedValue, charts])
  
//   // useEffect(() => {
//   //   console.log('charts effect: ', charts)
//   //   if(charts){
//   //     const string_date : string = Object.keys(charts)[0]
//   //     setSelectedValue(string_date)
//   //     Object.entries(charts);
//   //   }
//   // }, [charts])

//   useEffect(() => {
//     if (!charts) return;
  
//     const firstDate = Object.keys(charts)[0];
//     if (firstDate) {
//       setSelectedValue(firstDate);
//     }
//   }, [charts, selectedValue]);

//   useEffect(() => {
//     const chart = refreshChart()

//     return () => {
//       if (chart) {
//         chart.destroy()
//       }
//     }
    
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     chartRef, 
//     mode, 
//     chartsValues,
//     selectedValue
//   ])

//   useEffect(() => {
//     console.log('select value: ',selectedValue)
//     console.log("Charts select: ", charts)
//   }, [selectedValue])


//   const refreshChart = () => {
//     if (!chartRef.current) {
//       return
//     }

//     const height = parseInt(getCSS(chartRef.current, 'height'))

//     const chart = new ApexCharts(
//       chartRef.current, 
//       getChartOptions(
//         height, 
//         chartsValues.valores, 
//         chartsValues.metaDates, 
//         myPrognostics ? myPrognostics : null, 
//         largura
//       )
//     )
//     if (chart) {
//       chart.render()
//     }
//     return chart
//   }

//   if (!charts) {
//     return (
//       <div className={styles.divLoadingSpan}>
//         <LoadingSpan style={{marginLeft: '0.5rem'}}/>
//       </div>
//     )
//   }

//   return (
//     <div>
//       <div className={styles.divTitle}>
//         <h3 className='align-items-start flex-column'>
//           <span className={`fw-bold fs-${largura < 1200 ? '6' : '3'}`}>Ultimos 7 dias</span>
//         </h3>
//         <div className='card-toolbar' data-kt-buttons='true'>
//         </div>
//         <div className='text-hover-primary' onClick={() => {setShowCreateAppModal(true)}}>
//           <KTSVG 
//             path={'/media/icons/duotune/arrows/arr024.svg'} 
//             className={`svg-icon-muted svg-icon-2x ms-n1`} 
//           />
//         </div>
//       </div>

//       <div className=''>
//         <div 
//           style={{height: '235px'}}
//           ref={chartRef}  
//           id='kt_charts_widget_1_chart'
//           className={styles.divChartRef} 
//         />
//       </div>
//     </div>
//   )
// }

const BarGraph: React.FC<Props> = ({ charts, setShowCreateAppModal, myProg }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const chartInstance = useRef<ApexCharts | null>(null)
  const { mode } = useThemeMode()
  const { width: largura } = useSize()

  const [selectedValue, setSelectedValue] = useState<string>('')

  // Derivado: dados atuais do gráfico
  const currentChartData = useMemo(() => {
    if (!charts || !selectedValue || !charts[selectedValue]) {
      return { metaDates: [], valores: [], prognostico: [] }
    }

    const selectedChart = charts[selectedValue]

    const metaDates = 
      selectedChart.type === "mounth_charts" || selectedChart.type === "week_charts"
        ? selectedChart.dias || []
      : selectedChart.type === "year_charts"
        ? selectedChart.meses || []
      : selectedChart.type === "total_charts"
        ? selectedChart.anos || []
      : []

    const valores = selectedChart.valores || []

    let prognostico: number[] = []

    if (myProg && selectedChart.type === "week_charts") {
      const value = getShortMonthNameString(selectedValue)
      const value_prop = `prog_${value}`
      const value_final = myProg[value_prop as keyof Prognosis]

      if (typeof value_final === 'number') {
        prognostico = Array(metaDates.length).fill(parseFloat((value_final / 30).toFixed(2)))
      }
    }

    return { metaDates, valores, prognostico }
  }, [charts, selectedValue, myProg])

  // Selecionar primeira chave quando charts mudar
  useEffect(() => {
    if (charts && Object.keys(charts).length > 0 && !selectedValue) {
      setSelectedValue(Object.keys(charts)[0])
    }
  }, [charts, selectedValue])

  // Inicializar gráfico apenas uma vez
  useEffect(() => {
    if (!chartRef.current || !charts || Object.keys(charts).length === 0) return

    const height = parseInt(getCSS(chartRef.current, 'height')) || 235

    const chart = new ApexCharts(chartRef.current, getChartOptions(height, [], [], [], largura))
    chart.render()
    chartInstance.current = chart

    return () => {
      chart.destroy()
      chartInstance.current = null
    }
  }, []) // <- Só roda uma vez!

  // Atualizar dados do gráfico quando mudarem
  useEffect(() => {
    if (!chartInstance.current) return

    const { metaDates, valores, prognostico } = currentChartData

    chartInstance.current.updateOptions({
      xaxis: { categories: metaDates },
      colors: [getCSSVariableValue('--bs-primary'), '#f1416c'],
    })

    chartInstance.current.updateSeries([
      { name: 'Energia Gerada', type: 'bar', data: valores },
      { name: 'Prognóstico', type: 'line', data: prognostico }
    ])
  }, [currentChartData, largura, mode]) // Atualiza sempre que os dados mudam

  if (!charts || Object.keys(charts).length === 0) {
    return (
      <div className={styles.divLoadingSpan}>
        <LoadingSpan style={{ marginLeft: '0.5rem' }} />
      </div>
    )
  }

  return (
    <div>
      <div className={styles.divTitle}>
        <h3 className='align-items-start flex-column'>
          <span className={`fw-bold fs-${largura < 1200 ? '6' : '3'}`}>Últimos 7 dias</span>
        </h3>
        <div className='text-hover-primary' onClick={() => setShowCreateAppModal(true)}>
          <KTSVG path={'/media/icons/duotune/arrows/arr024.svg'} className={`svg-icon-muted svg-icon-2x ms-n1`} />
        </div>
      </div>

      <div style={{ height: '235px' }} ref={chartRef} className={styles.divChartRef} />
    </div>
  )
}

export {BarGraph}

function getChartOptions(
  height: number, 
  valores: number[], 
  metaDates: string[], 
  prognostico?: number[], 
  largura? : number
): ApexOptions {

  const labelColor = getCSSVariableValue('--bs-gray-500')
  const borderColor = getCSSVariableValue('--bs-gray-200')
  const baseColor = getCSSVariableValue('--bs-primary')
  const secondaryColor = getCSSVariableValue('--bs-gray-300')

  return {
    series: [
      {
        name: 'Energia Gerada',
        type: 'bar',
        data: valores,
      },
      {
        name: 'Prognóstico',
        type: 'line',
        //data: Array(metaDates.length).fill(prognostico ? parseFloat(((prognostico/12)/30).toFixed(2)) : 0) 
        data: prognostico ? prognostico : []
      }
    ],
    chart: {
      fontFamily: 'inherit',
      type: 'bar',
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        borderRadius: 5,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: [0, 3],
      colors: ['transparent', '#f1416c'],
      curve: 'smooth'
    },
    xaxis: {
      categories: metaDates,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: largura && largura < 1200 ? '9px' : '14px',
        },
      },
    },
    yaxis: [
      {
        min: 0,
        seriesName: 'Energia Gerada',
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: baseColor
        },
        labels: {
          style: {
            colors: baseColor,
          }
        },
        title: {
          text: "Geração (KWh)",
          style: {
            color: baseColor,
          }
        },
        tooltip: {
          enabled: true
        }
      },
    ],
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val, { series, seriesIndex, dataPointIndex, w }) {
          if (seriesIndex === 1) {
            return val + ' KWh (Prognóstico)';
          }
          return val + ' KWh';
        },
      },
    },
    colors: [baseColor, secondaryColor],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  };
}
